module.exports = __webpack_public_path__ + "img/4.b7fcc049.jpg";